import dedent from "dedent";
import { codeList } from "./codeList";

interface EmbedCodeProps {
  width: string;
  isTransparent: boolean;
  colorTheme: 'light' | 'dark';
  embedCodeConfig: EmbedCodeConfig; 
  formattedConfig?: string;
}

function EmbedCode({
  width,
  isTransparent,
  colorTheme,
  embedCodeConfig, 
  formattedConfig, 
}: EmbedCodeProps) {

  const configObject = {
    width,
    isTransparent,
    colorTheme,
  };
  
  const formattedConfig2 = dedent(`
    const config = ${
      JSON.stringify(configObject, null, 2)
        .split("\n")
        .map(line => line !== '{' ? "                             " + line : line) 
        .join("\n")
     }
`); 

 
  return (
    <div className="w-full">
      <div className='text-[20px] font-semibold'>Embed code</div>
      <div className='w-full bg-slate-100 rounded-lg shadow-md border border-gray-200 mt-4 px-1'>
        <div className='whitespace-pre-wrap w-full text-[12px] lg:text-[14px] text-gray-600 font-medium break-words p-2'>
         {embedCodeConfig && codeList.embed_code_copy(embedCodeConfig, { width, isTransparent, colorTheme, formattedConfig: formattedConfig ?? formattedConfig2})}
        </div>
      </div>
    </div>
  );
}

export default EmbedCode;
